import { useStateValue } from '../../Contexto/store';
import React, { useState, useEffect, Fragment } from 'react';
import { Container, List } from '@mui/material';
import Enumerable from 'linq';

import SetModulos from '../../Configuracion/SetModulos/SetModulos'
import style from '../Tool/Style'
import DetalleModulo from './DetalleModulo'
import DetalleModuloExterno from './DetalleModuloExterno'

import DiccionarioEtiquetas from '../../Configuracion/Idiomas/Etiquetas_Diccionario';
import ImgClassStore from '../../Activos/Imagenes/Modulos/classStore.svg';

const Home = () => {

    const [{ autorizacionMod, autorizacionModExternal, etiquetasIdioma, cargandoRed }, dispatch] = useStateValue();

    const [autorizaUsuarioMod, setAutorizaUsuarioMod] = useState({
        Modulos: autorizacionMod ? autorizacionMod.Modulos : SetModulos.Modulos
    });

    const [modulosFavoritos, SetModulosFavoritos] = useState([]);
    const [modulosFavoritosCS, SetModulosFavoritosCS] = useState([]);

    //const [modulosEsternos, SetModulosModulos] = useState([]);

    // Se declara la variable de estado que representa al idioma para las etiquetas del componente
    const [etiquetas, setEtiquetas] = useState({
        EtiquetasComponente: etiquetasIdioma ? etiquetasIdioma.EtiquetasComponente : DiccionarioEtiquetas.IdiomaDefault.Etiquetas,
        CodigoIdioma: etiquetasIdioma ? etiquetasIdioma.CodigoIdioma : DiccionarioEtiquetas.CodigoIdioma
    });

    useEffect(() => {
        // se llama al dispatch para que como tal se actualice el reducer
        setEtiquetas({
            EtiquetasComponente: etiquetasIdioma ? etiquetasIdioma.EtiquetasComponente : DiccionarioEtiquetas.IdiomaDefault.Etiquetas,
            CodigoIdioma: etiquetasIdioma ? etiquetasIdioma.CodigoIdioma : DiccionarioEtiquetas.CodigoIdioma
        });

    }, [etiquetasIdioma]);

    useEffect(() => {
        dispatch({ type: "LOAD_COMP", texto: etiquetas.EtiquetasComponente.CargandoModal.Et_Cargando });

        // se valida se por alguna autorizacion y cambio en el estado el usuario se le restringe o da acceso a algun modulo
        let autorizacionUsuarioModulos = autorizacionMod ? autorizacionMod : SetModulos;

        let modulosSistema = Enumerable.from(autorizacionUsuarioModulos.Modulos)
            .groupBy(
                x => x.Titulo,
                Titulo => Titulo,
                (key, items) => ({ key, items: items.toArray() }
                )).toArray();

        // se llama al dispatch para que como tal se actualice el reducer
        setAutorizaUsuarioMod({ Modulos: modulosSistema });

        let temporal = Enumerable.from(autorizacionUsuarioModulos.Modulos).where(x => x.Favorites === true).toArray();

        //let temporalEsternos = Enumerable.from(autorizacionUsuarioModulos.Modulos).where(x => x.ModuloExterno === true)
        //    .groupBy(
        //        x => x.Titulo,
        //        Titulo => Titulo,
        //        (key, items) => ({ key, items: items.toArray() }
        //        )).toArray();

        //SetModulosModulos(temporalEsternos);

     

        var modulosFavoritosTemp = [];
        for (var k = 0; k < temporal.length; k++) {
            modulosFavoritosTemp[k] = Object.assign({}, temporal[k]);
        }

        modulosFavoritosTemp.map(function (dato) {
            dato.Modulo = "Favoritos";
            return dato;
        });

        let modulosFavoritos = Enumerable.from(modulosFavoritosTemp)
            .groupBy(
                x => x.Modulo,
                Modulo => Modulo,
                (key, items) => ({ key, items: items.toArray() }
                )).toArray();

        if (autorizacionModExternal?.Modulos !== undefined && autorizacionModExternal?.Modulos !== null) {
            if (autorizacionModExternal.Modulos.length > 0) {
                let favoritosCSItems = autorizacionModExternal.Modulos[0].items.filter(item => item.FavoritesDB === true);

                if (favoritosCSItems.length > 0) {
                    const favoritosCSItemsAjuste = favoritosCSItems.map(elemento => {
                        return {
                            IdModulo: elemento.IdModuloDB,
                            Modulo: elemento.ModuloDB,
                            Titulo: elemento.TituloDB,
                            Submodulo: elemento.SubmoduloDB,
                            UrlModulo: elemento.UrlModuloDB,
                            Leyenda: elemento.LeyendaDB,
                            Imagen: "",
                            Acceso: true,
                            Favorites: elemento.FavoritesDB,
                            Icono: elemento.IconoDB,
                            Referencia: elemento.Referencia,
                            ModuloExterno: elemento.ModuloExterno
                        }
                    });

                    if (modulosFavoritos.length > 0)
                        modulosFavoritos[0].items = modulosFavoritos[0].items.concat(favoritosCSItemsAjuste)
                    else {                        
                        let autorizacionModExternalTemp = autorizacionModExternal;

                        if (autorizacionModExternalTemp.Modulos.length > 0) {
                            autorizacionModExternalTemp.Modulos.map(function (dato) {
                                dato.Modulo = "Favoritos";
                                return dato;
                            });

                            modulosFavoritos = autorizacionModExternalTemp.Modulos;
                            //modulosFavoritos = Enumerable.from(autorizacionModExternalTemp)
                            //    .groupBy(
                            //        x => x.Modulo,
                            //        Modulo => Modulo,
                            //        (key, items) => ({ key, items: items.toArray() }
                            //        )).toArray();


                            modulosFavoritos[0].items = favoritosCSItemsAjuste;
                        }
                    }
                }
            }        
       
        }
        
        SetModulosFavoritos(modulosFavoritos);

        dispatch({ type: "CLOSE_LOAD_COMP" });
    }, [autorizacionMod]);

    return (
        <div style={style.form}>
            <Fragment>
                <Container component="main" justify="center" maxWidth='100%'>
                    <List>
                        {
                            modulosFavoritos.map(function (currentelement, index) {
                                console.log("favoritos", currentelement)
                                return Enumerable.from(currentelement.items).any(element => element.Acceso === true) ? (<DetalleModulo key={currentelement.key}
                                    listaSubmodulos={currentelement.items}
                                    Header={etiquetas.EtiquetasComponente.DetalleModulo.Et_TituloFavoritos}
                                    Detalles={false}
                                    LastOne={index + 1 === modulosFavoritos.length} />
                                )
                                    : (null)
                            })
                            //modulosFavoritos.map((elementoMenu, key, i) =>
                            //Enumerable.from(elementoMenu.items).any(element => element.Acceso === true) ? (<DetalleModulo key={key}
                            //    listaSubmodulos={elementoMenu.items}
                            //    Header={etiquetas.EtiquetasComponente.DetalleModulo.Et_TituloFavoritos}
                            //    Detalles={false}
                            //    LastOne={index + 1 === modulosFavoritos.length} />
                            //)
                            //    : (null)
                            //)
                        }
                        {
                            autorizaUsuarioMod.Modulos.map(function (currentelement, index) {
                                console.log("regular", currentelement)
                                return Enumerable.from(currentelement.items).any(element => element.Acceso === true) ? (<DetalleModulo key={currentelement.key}
                                    listaSubmodulos={currentelement.items}
                                    Header={currentelement.key}
                                    Detalles={true}
                                    LastOne={index + 1 === autorizaUsuarioMod.Modulos.length && autorizacionModExternal.Modulos.length === 0} />)
                                    : (null)
                            })


                            //autorizaUsuarioMod.Modulos.map((elementoMenu, key, { index }) =>
                            //console.log('ss', index)
                            //Enumerable.from(elementoMenu.items).any(element => element.Acceso === true) ? (<DetalleModulo key={key}
                            //    listaSubmodulos={elementoMenu.items}
                            //    Header={elementoMenu.key}
                            //    Detalles={true}
                            //    LastOne={index + 1 === autorizaUsuarioMod.Modulos.length} />)
                            //    : (null)
                            //)


                        }

                        {
                            autorizacionModExternal.Modulos.map(function (currentelement, index) {
                                console.log("external", currentelement)
                                return <DetalleModuloExterno key={currentelement.key}
                                    Imagen={ImgClassStore}
                                    listaSubmodulos={currentelement.items}
                                    Header={currentelement.key}
                                    Detalles={true}
                                    LastOne={index + 1 === autorizacionModExternal.Modulos.length} />
                            })

                            //autorizaUsuarioMod.Modulos.map((elementoMenu, key, {index}) =>
                            //console.log('ss', index)
                            //Enumerable.from(elementoMenu.items).any(element => element.Acceso === true) ? (<DetalleModulo key={key}
                            //    listaSubmodulos={elementoMenu.items}
                            //    Header={elementoMenu.key}
                            //    Detalles={true}
                            //    LastOne={index + 1 === autorizaUsuarioMod.Modulos.length} />)
                            //    : (null)
                            //)


                        }
                    </List>
                </Container>
            </Fragment>
        </div>
    );
};

export default Home;